import { render } from "./addAcupoint.vue?vue&type=template&id=68752fe1&scoped=true"
import script from "./addAcupoint.vue?vue&type=script&lang=js"
export * from "./addAcupoint.vue?vue&type=script&lang=js"

import "./addAcupoint.vue?vue&type=style&index=0&id=68752fe1&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68752fe1"]])

export default __exports__